import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import OfferingModal from './OfferingModal';
import PincodeModal from './PincodeModal';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { getDecryptedUserFromCookie } from './utils/getCookie';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, LucideToggleLeft, LucideToggleRight, Pencil, Trash2 } from 'lucide-react';
import { useSearch } from '../SearchContext';
import Loader from './Loader';
import { decryptToken } from './utils/getToken';

const Pincode = () => {

    const { globalSearch } = useSearch();
    const [searchQuery, setSearchQuery] = useState('');
    const [pincodes, setPincodes] = useState([]);
    const [filteredPincodes, setFilteredPincodes] = useState(pincodes);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const userData = getDecryptedUserFromCookie("gta_mainstateuser");
    const token = decryptToken("accessToken") || ""
    const urlmain = process.env.REACT_APP_LINK
    const [pincodeData, setPincodeData] = useState({
        pincode: "",
        status: "",
        user_id: userData.main_id,
        user_name: userData.full_name,
        available: ""
    })
    const [load, setLoad] = useState(false);
    const [editingPincode, setEditingPincode] = useState(null);
    const [loadButton, setLoadButton] = useState(false);

    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const availableOptions = [
        { value: 'Include', label: 'Include' },
        { value: 'Exclude', label: 'Exclude' },
    ];

    // Effect to handle filtering
    useEffect(() => {
        const filtered = pincodes.filter((pincode) =>
            Object.values(pincode).some((value) =>
                String(value).toLowerCase().includes(globalSearch.toLowerCase())
            )
        );
        setFilteredPincodes(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [globalSearch, pincodes]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredPincodes.length / itemsPerPage);
    const currentData = filteredPincodes.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // const updatePincodeInList = (updatedPincode) => {
    //     setPincodes(prev =>
    //         prev.map(p =>
    //             p.id === updatedPincode.id ? updatedPincode : p
    //         )
    //     );
    // };
    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Toggle Status


    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`${urlmain}/pincode/${id}`, {
                        method: 'DELETE',
                        headers: {
                            Authorization: `Bearer ${token}`,
                        }
                    });

                    const res = await response.json();

                    if (response.ok) {
                        setPincodes(prev => prev.filter(p => p.id !== id));
                        Swal.fire('Deleted!', res.message || 'Pincode has been deleted.', 'success');
                    } else {
                        Swal.fire('Error!', res.message || 'Failed to delete pincode.', 'error');
                    }
                } catch (error) {
                    console.error('Delete failed', error);
                    Swal.fire('Error!', 'Something went wrong.', 'error');
                }
            }
        });
    };

    const fetchData = async () => {
        setLoad(true);
        try {
            const response = await fetch(`${urlmain}/pincode/admin/${userData.main_id}`)
            const res = await response.json();

            setPincodes(res.pincodesData);
        } catch (error) {
            console.error(error);
        } finally {
            setLoad(false);
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPincodeData((prev) => ({ ...prev, [name]: value }));
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     try {
    //         const newItem = {
    //             pincode: pincodeData.pincode,
    //             status: pincodeData.status?.value
    //         };
    //         const response = await fetch(`${urlmain}/pincode`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json"
    //             },
    //             body: JSON.stringify(newItem)
    //         })
    //         const res = await response.json();
    //         if (response.ok) {
    //             setPincodes(prev => [...prev, newItem]);
    //             setIsModalOpen(false)
    //         }
    //     } catch (error) {
    //         console.error(error)
    //     }
    // }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoadButton(true);
        const newItem = {
            pincode: pincodeData.pincode,
            status: pincodeData?.status.value,
            available: pincodeData?.available.value,
            user_id: userData.main_id,
            user_name: userData.full_name
        };

        if (pincodeData.pincode.length !== 6 || !/^\d{6}$/.test(pincodeData.pincode)) {
            alert("Pincode must be exactly 6 digits");
            return;
        }

        try {
            const isEdit = !!pincodeData.id;
            const url = isEdit
                ? `${urlmain}/pincode/${pincodeData.id}`
                : `${urlmain}/pincode`;

            const method = isEdit ? 'PUT' : 'POST';

            const response = await fetch(url, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(newItem)
            });

            const res = await response.json();

            if (response.ok) {
                if (isEdit) {
                    setPincodes((prev) =>
                        prev.map((p) =>
                            p.id === pincodeData.id ? { ...newItem, id: pincodeData.id } : p
                        )
                    );
                    toast.success("Pincode Updated", {
                        position: "top-center",
                        autoClose: 2000
                    })
                } else {
                    setPincodes((prev) => [...prev, { ...newItem, id: res.id || Date.now() }]);
                    toast.success("Pincode Added", {
                        position: "top-center",
                        autoClose: 2000
                    })
                    fetchData();
                }

                // ✅ Cleanup modal
                setIsModalOpen(false);
                setPincodeData({ pincode: "", status: "" });
            }
        } catch (error) {
            console.error("Error:", error);
        }
        finally{
            setLoadButton(false)
        }
    };

    const toggleStatus = async (id) => {
        try {
            const response = await fetch(`${urlmain}/pincode/status/${id}`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            });

            const res = await response.json();

            if (response.ok) {
                setPincodes(prev =>
                    prev.map(p =>
                        p.id === id ? { ...p, status: res.data.status } : p
                    )
                );
                toast.success(res.message, {
                    position: "top-center",
                    autoClose: 2000

                })
            }
        } catch (error) {
            console.error("Toggle status failed", error);
        }
    };



    useEffect(() => {
        fetchData();
    }, [])

    if (load) {
        return (
            <Loader />
        );
    }

    return (
        <>
            <div className="oms-header">
                <h1 className="dashboard-title">Pincode</h1>

                {/* Add Offers Button */}
                <button className="oms-add-btn" onClick={() => {
                    setIsModalOpen(true)
                    setPincodeData({
                        pincode: "",
                        status: "",
                        user_id: userData.main_id,
                        user_name: userData.full_name,
                        available: ""
                    })
                }}>
                    Add Pincode
                </button>
            </div>

            {/* Search Filter */}
            {/* <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> 
                    </div>
                </div> */}

            {/* Customer Table */}
            <div className="customer-table responsive-table">
                <table>
                    <thead>
                        <tr>
                            <th>Pincode</th>
                            <th>Available</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentData.length > 0 ? (
                            currentData.map((customer, index) => (
                                <tr key={index}>
                                    <td>{customer.pincode}</td>
                                    <td>{customer.available}</td>
                                    <td>
                                        <button
                                            className={`status-toggle ${customer.status === 'Active' ? 'active' : 'inactive'}`}
                                            onClick={() => toggleStatus(customer.id)}
                                        >
                                            {customer.status === 'Active' ? (
                                                <i className="fas fa-toggle-on"></i>
                                            ) : (
                                                <i className="fas fa-toggle-off"></i>
                                            )}
                                        </button>

                                    </td>
                                    <td>
                                        <button className="edit-button" onClick={() => {
                                            setIsModalOpen(true)
                                            setPincodeData({
                                                id: customer.id, // ✅ Needed to detect edit mode
                                                pincode: customer.pincode,
                                                status: statusOptions.find(opt => opt.value === customer.status),
                                                user_id: userData.main_id,
                                                user_name: userData.full_name,
                                                available: availableOptions.find(opt => opt.value === customer.available),
                                            });
                                        }}
                                        >
                                            <i className="fa-solid fa-pencil edit-oms"></i>
                                        </button>
                                        <button
                                            className="delete-button"
                                            onClick={() => handleDelete(customer.id)}
                                        >
                                            <i className="fa-solid fa-trash delete-oms"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" style={{ textAlign: 'center' }}>No pincodes found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="ecom-responsive-cards">
                {currentData.length === 0 ? (
                    <p style={{ textAlign: "center", margin: "50px" }}>No Pincode Added</p>
                ) : (
                    currentData.map((group, index) => (
                        <div className="ecom-responsive-card" key={index}>
                            <div className="ecom-responsive-header">
                                <div className='p-toggle'>
                                    <p onClick={() => {
                                        setPincodeData({
                                            id: group.id,
                                            pincode: group.pincode,
                                            status: statusOptions.find(opt => opt.value === group.status),
                                            user_id: userData.main_id,
                                            user_name: userData.full_name,
                                            available: availableOptions.find(opt => opt.value === group.available),
                                        });
                                        setIsModalOpen(true);
                                    }}>
                                        <Pencil size={20} style={{ marginRight: 4 }} /> <span>Edit</span>
                                    </p>

                                    <button
                                        className={`status-toggle ${group.status === "Active" ? 'Active' : 'Inactive'}`}
                                        onClick={() => toggleStatus(group.id, group.status)}
                                    >
                                        {group.status === "Active" ? (
                                            <>
                                                <LucideToggleRight style={{ marginRight: 4 }} />
                                                <span>Active</span>
                                            </>
                                        ) : (
                                            <>
                                                <LucideToggleLeft style={{ marginRight: 4 }} />
                                                <span>Inactive</span>
                                            </>
                                        )}
                                    </button>
                                </div>

                                <p onClick={() => handleDelete(group.id)}>
                                    <Trash2 size={20} style={{ marginRight: 4 }} /> <span>Delete</span>
                                </p>
                            </div>

                            <div className="ecom-responsive-body">
                                <div className="ecom-responsive-left">
                                    <h2>{group.pincode || "Not Provided"}</h2>
                                    <p>Available: {group.available}</p>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>

            {totalPages > 1 && (

                <div className="pagination">
                    {/* First Page */}
                    <button
                        onClick={() => paginate(1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronsLeft size={18} />
                    </button>

                    {/* Previous Page */}
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronLeft size={18} />
                    </button>

                    {/* Current Page Number Only */}
                    <button className="pagination-btn active">
                        {currentPage}
                    </button>

                    {/* Next Page */}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronRight size={18} />
                    </button>

                    {/* Last Page */}
                    <button
                        onClick={() => paginate(totalPages)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronsRight size={18} />
                    </button>
                </div>
            )}

            <PincodeModal isOpen={isModalOpen} setIsOpen={setIsModalOpen}
                pincodeData={pincodeData}
                setPincodeData={setPincodeData} handleChange={handleChange} handleSubmit={handleSubmit}
                statusOptions={statusOptions}
                availableOptions={availableOptions}
                loadButton={loadButton}
            />
        </>
    );
};

export default Pincode;
